import { type ChatConversationViewModel } from '../chat.models';
import { type ConversationsFilter } from '../conversations-filters/conversations-filters.component';

export function filterConversations(
  conversations: ChatConversationViewModel[],
  filter: ConversationsFilter,
  unreadCounts: ReadonlyMap<number, number>,
  selectedConversationId: number | undefined,
): ChatConversationViewModel[] {
  if (filter !== 'unread') {
    return conversations;
  }
  return conversations.filter(
    (conversation) =>
      conversation.id === selectedConversationId || (unreadCounts.get(conversation.id) ?? 0) > 0,
  );
}
